import { Tooltip } from "antd";
import { FolderOpenFilled } from "@ant-design/icons";

const Columns = (handleOpenChangeLog, dependenciesDeletedTableFilter) => {

  const { filterTypes, filterAssets, filterAreas, dashboardAssetsFilter, dashboardAreasFilter } = dependenciesDeletedTableFilter();

  return [
    { 
      title: 'Activos', 
      dataIndex: ['asset', 'name'], 
      key: 'asset',
      sorter: (a, b) => (a.asset?.name || '').localeCompare(b.asset?.name || ''),
      defaultFilteredValue: dashboardAssetsFilter,
      filters: filterAssets?.map(asset => ({ text: asset?.name || 'N/A', value: asset?.name || 'N/A' })) || [],
      onFilter: (value, record) => (record.asset?.name || '').includes(value),
      render: (text) => text || 'N/A',
      onHeaderCell: () => ({
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      width: '15%',
    },
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#FDE2E2",
          color: "#B22222",
          fontWeight: "bold",
        },
      }),
      showSorterTooltip: false,
      width: "25%",
    },
    {
      title: "Descripción",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => a.description.localeCompare(b.description),
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#FDE2E2",
          color: "#B22222",
          fontWeight: "bold",
        },
      }),
      showSorterTooltip: false,
      width: "40%",
    },
    {
      title: 'Atributos',
      dataIndex: 'atributes',
      key: 'atributes',
      render: (atributes) => {
        const validAttributes = atributes?.filter(attr => attr?.atribute?.key) || [];
      
        if (!validAttributes.length) return <span style={{ color: '#999' }}>N/A</span>;
      
        return (
          <Tooltip
            title={
              <div style={{ maxWidth: 300 }}>
                <ul style={{ paddingLeft: 16, margin: 0 }}>
                  {validAttributes.map((attr, index) => (
                    <li key={index} style={{ marginBottom: 4 }}>
                      <strong>{attr.atribute.key}:</strong>{' '}
                      <span style={{ marginLeft: 5 }}>{attr.value || 'N/A'}</span>
                    </li>
                  ))}
                </ul>
              </div>
            }
          >
            <span style={{ color: '#006939',  }}>
              Ver Atributos ({validAttributes.length})
            </span>
          </Tooltip>
        );
      },           
      onHeaderCell: () => ({ style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '15%',
    },
    { 
      title: 'Tipo', 
      dataIndex: ['type', 'name'], 
      key: 'type',
      sorter: (a, b) => (a.type?.name || '').localeCompare(b.type?.name || ''),
      filters: filterTypes?.map(type => ({ text: type?.name || 'N/A', value: type?.name || 'N/A' })) || [],
      onFilter: (value, record) => (record.type?.name || '').includes(value),
      render: (text) => text || 'N/A',
      onHeaderCell: () => ({ style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' }, className: 'custom-filter-icon' }),
      showSorterTooltip: false,
      width: '15%',
    },
    {
      title: "Responsable",
      dataIndex: "area",
      key: "area",
      sorter: (a, b) =>
        (a.area?.name || "").localeCompare(b.area?.name || ""),
      defaultFilteredValue: dashboardAreasFilter,
      filters: filterAreas?.map(area => ({
        text: area.name,
        value: area.name
      })),
      onFilter: (value, record) => (record.asset?.area?.name || '') === value,
      render: (text, record) => record.asset?.area?.name || 'N/A',
      onHeaderCell: () => ({
        style: {
          backgroundColor: "#FDE2E2",
          color: "#B22222",
          fontWeight: "bold",
        },
      }),
      showSorterTooltip: false,
      width: "20%",
    },
    {
      title: "Log",
      dataIndex: "log",
      key: "log",
      onHeaderCell: () => ({ 
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' } 
      }),
      width: '5%',
      render: (_, record) => (
        <div style={{ textAlign: 'center' }}>
          <Tooltip title="Ver Log">
            <FolderOpenFilled 
              style={{ fontSize: 20, cursor: 'pointer', color: '#B22222' }}
              onClick={() => handleOpenChangeLog(record)}
            />
          </Tooltip>
        </div>
      )
    }
  ];
};

export default Columns;
